import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

const useUpdateVesselDocuments = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const updateVesselDocuments = async ({ vesselId, documents }) => {
    const formData = new FormData();
    documents.forEach((doc) => {
      formData.append(doc.name, doc.file);
    });

    const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/vessel/update/documents/${vesselId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  };

  return useMutation(updateVesselDocuments, {
    onSuccess: () => {
      queryClient.invalidateQueries("vessels"); 
    },
    onError: (error) => {
      console.error("Error updating vessel documents:", error);
      throw new Error(error.response?.data?.message || "Failed to update vessel documents");
    },
  });
};

export default useUpdateVesselDocuments;
